import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { APIService } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private apiService: APIService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // here we check if Agencies is premium or not
    // the authService returs user object, or
    // it returns undefined/null when user is not logged in
    
    // SINCE OUR 'authService.user' IS OF TYPE 'Observable'
    // WE MUST USE 'subscribe' TO GET VALUE OF 'user'
    return new Promise((resolve, reject) => {
      if (this.apiService.checkisIndianAgency() == false){
        if(this.apiService.checkIsPremiumOrTrial() == false){
          if(this.apiService.fn_isLiveURL() == true) {
            window.open("https://biziverse.com/main.html#/home?isUpMdl=1", "_self");
          }
          else{
            window.open("http://localhost:50414/main.html#/home?isUpMdl=1", "_self");
          }
        }
        else {
          let url = String(state.url).split("/")[1];
          if(url == "Stock" || url == "Tasks"|| url == "Stores"|| url == "Categories"|| url == "Units" || 
              url == "transfer"){
            return resolve(true);
          }
          else{
            if(this.apiService.fn_isLiveURL() == true) {
              window.open("https://biziverse.com/main.html#/home?isUpMdl=1", "_self");
            }
            else{
              window.open("http://localhost:50414/main.html#/home?isUpMdl=1", "_self");
            };
          };          
        };
      }
      else{
        if(this.apiService.checkIsPremiumOrTrial() == false || this.apiService.checkBzvzEdition() != 3){

          let erpAgn: any = this.apiService.getCookie("ERP_Agn");
          let agn: any = this.apiService.getCookie("M");
          let agnERPRight: any = {
            EnblAccounts: false,
            EnblInventory: false,
            EnblProduction: false,
            ETS: false
          }
          if (erpAgn) {
              erpAgn = JSON.parse(erpAgn);
              if (erpAgn.length > 0) {
                  agnERPRight.EnblAccounts = erpAgn[0].EnblAccounts;
                  agnERPRight.EnblInventory = erpAgn[0].EnblInventory;
                  agnERPRight.EnblProduction = erpAgn[0].EnblProduction;
              }
          }

          if(agn){
            agn = JSON.parse(agn);
            if(agn.length > 0){
              agnERPRight.ETS = agn[0].ETS ? agn[0].ETS : false;
            }
          }

          let url = String(state.url).split("/")[1];
          if(agnERPRight.EnblAccounts && ((url.startsWith("accounts", 0) == true || url.startsWith("LedgerRecord", 0) == true|| url.startsWith("voucherPrint", 0) == true|| 
              url.startsWith("AcctReport", 0) == true|| url.startsWith("balanceSheet", 0) == true || 
              url.startsWith("profitandLoss", 0) == true || url.startsWith("trialBalance", 0) == true || 
              url.startsWith("GSTR3B", 0) == true || url.startsWith("Reconciliation", 0) == true || 
              url.startsWith("dailyStock", 0) == true || url.startsWith("voucher", 0) == true) || 
              (this.apiService.checkBzvzEdition() == 4 && this.apiService.checkIsPremiumOrTrial() == true) ||
              this.apiService.checkIsPremiumPaid() == true)){
            return resolve(true);
          }
          else if(agnERPRight.EnblInventory && (url.startsWith("Stock", 0) == true || url.startsWith("Stores", 0) == true|| 
                  url.startsWith("Categories", 0) == true || url.startsWith("Units", 0) == true || 
                  url.startsWith("transfer", 0) == true || url.startsWith("Tasks", 0) == true ||
            url.startsWith("transactionHistory", 0) == true || url.startsWith("StockExpand", 0) == true) ||
            this.apiService.checkIsPremiumPaid() == true) {
            return resolve(true);
          }
          else if(agnERPRight.EnblProduction && (url.startsWith("ProductionList", 0) == true || 
                    url.startsWith("ProductionSettings", 0) == true || url.startsWith("StageConfig", 0) == true || 
                    url.startsWith("RejectionReasons", 0) == true || url.startsWith("transactionJobs", 0) == true || 
            url.startsWith("jobcardPrint", 0) == true) || this.apiService.checkIsPremiumPaid() == true) {
            return resolve(true);
          }
          else if(agnERPRight.ETS && url.startsWith("Tasks", 0) == true || this.apiService.checkIsPremiumPaid() == true){
              return resolve(true);
          }
          else{
            if(this.apiService.fn_isLiveURL() == true) {
              window.open("https://biziverse.com/main.html#/home?isUp=1", "_self");
            }
            else{
              window.open("http://localhost:60228/main.html#/home?isUp=1", "_self");
            }
          }          
        }
        else {
          return resolve(true);          
        }
      }     
    });
  }
}
